export default {
      id: "stepPatternMask-usage",
      viewBox: "0 0 179 155",
      url: __webpack_public_path__ + "sprite.svg#stepPatternMask",
      toString: function () {
        return this.url;
      }
    }